import { Box, Button, IconButton, InputAdornment, Paper, Typography, TextField } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { PuiFormikForm, PuiGrid, PuiLoadingBackdrop, PuiTextField, useAlert } from "@portnet/ui";
import { Formik } from "formik";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { CONSULTATION_TRANSACTIONS_PAGE_ROUTE } from "../../../../common/constants/routerConstants";
import { LOGIN_ERROR_MESSAGE, LOGIN_SUCCESSED_MESSAGE } from "../../../../common/router/others/routerMessages";
import * as loginFormNames from "../others/loginFormNames";
import { loginInitialValues } from "../others/loginInitialValues";
import { loginValidationSchema } from "../others/loginValidationSchemas";
import { loginAction, registerMFA, sendOtpMail ,loginSuccessAction} from "../state/loginActions";
import { Visibility, VisibilityOff, Lock } from "@mui/icons-material";
import { Person } from "@mui/icons-material";
import MFAPopup from "./MFAPop";
import logo from "../../../../assets/nouvelle tarification.png";

const LoginPage = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const alertDispatch = useAlert();
    const dispatch = useDispatch();
    const formRef = React.useRef();
    const formValuesRef = useRef({});

    const [showPassword, setShowPassword] = useState(false);
    const [showMfaPopup, setShowMfaPopup] = useState(false);
    const [showOtpVerification, setShowOtpVerification] = useState(false);
    const [codeOTP, setCodeOTP] = useState(null);
    const [mfaErrorMessage, setMfaErrorMessage] = useState("");
    const [otpMessage, setOtpMessage] = useState("");
    const [otpError, setOtpError] = useState("");

    const {
        isLoading: isLoginLoading,
        isSuccessed: isLoginSuccessed,
        hasError: hasLoginError,
        requireOTP,
        qrCodeUrl,
        secret,
        messageMfa,
        mfaErrorMessage: mfaErrorFromStore,
        otpMailError,
        error: loginError,
    } = useSelector((state) => state.auth.login);

        const loginState = useSelector((state) => state.auth.login);

        useEffect(() => {
            console.log("full login state:", loginState); 
        }, [loginState]);
    const tokenFromStore = useSelector((state) => state.auth.login.token);

    const handleClickShowPassword = () => setShowPassword(!showPassword);

    const submitHandler = (values) => {
        formValuesRef.current = values;
        dispatch(loginAction({ ...values, otp: codeOTP }));
    };

  
    useEffect(() => {
        console.log("isLoginSuccessed changed:", isLoginSuccessed); 
        if (isLoginSuccessed) {
            navigate(CONSULTATION_TRANSACTIONS_PAGE_ROUTE);
            alertDispatch("success", LOGIN_SUCCESSED_MESSAGE);
        }
    }, [isLoginSuccessed]);

    useEffect(() => {
        if (mfaErrorFromStore) {
            alertDispatch("error", mfaErrorFromStore);
        }
    }, [mfaErrorFromStore]);
    useEffect(() => {
        if (hasLoginError && !showOtpVerification) {
            alertDispatch("error", LOGIN_ERROR_MESSAGE);
        }
    }, [hasLoginError, showOtpVerification]);

    useEffect(() => {
        if (tokenFromStore) {
            setShowMfaPopup(false);
            setShowOtpVerification(false);
            setCodeOTP(null);
        }
    }, [tokenFromStore]);

    useEffect(() => {
        if (requireOTP === "true") {
            setShowOtpVerification(true);
        }
    }, [requireOTP]);


    useEffect(() => {
        if (qrCodeUrl) {
            setShowMfaPopup(true);
        }
    }, [qrCodeUrl]);

        useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const tokenFromUrl = params.get("token");
        if (tokenFromUrl) {
            sessionStorage.setItem("token", tokenFromUrl);
            dispatch(loginSuccessAction(tokenFromUrl));
            navigate(CONSULTATION_TRANSACTIONS_PAGE_ROUTE);
        }
    }, []); 

  
    useEffect(() => {
        if (messageMfa) {
            setOtpMessage(messageMfa);
        }
    }, [messageMfa]);

   
    useEffect(() => {
        if (mfaErrorFromStore) {
            setMfaErrorMessage(mfaErrorFromStore);
            setCodeOTP(null);
        }
    }, [mfaErrorFromStore]);

   
    useEffect(() => {
        if (otpMailError) {
            setOtpError("Erreur lors de l'envoi du code OTP. Veuillez réessayer.");
        }
    }, [otpMailError]);

    const handleMailClick = () => {
        setOtpError("");
        dispatch(sendOtpMail({
            username: formValuesRef.current.username,
            password: formValuesRef.current.password,
            otp: codeOTP,
            secret: secret,
        }));
    };

    const handleRegisterClick = () => {
        setMfaErrorMessage("");
        dispatch(registerMFA({
            enableMailMfa: true,
            username: formValuesRef.current.username,
            password: formValuesRef.current.password,
            otp: codeOTP,
            secret: secret,
        }));
        setCodeOTP(null);
    };

    return (
        <>
            <PuiLoadingBackdrop open={isLoginLoading} />
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: (t) => alpha(t.palette.primary.main, 0.1),
                    padding: 3,
                }}
            >
                <Paper
                    sx={{
                        width: "650px",
                        height: "500px",
                        display: "flex",
                        borderRadius: "25px",
                        overflow: "hidden",
                        backgroundColor: (t) => alpha(t.palette.background.paper, 0.9),
                        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                    }}
                >
                 
                    <Box
                        sx={{
                            flex: 1,
                            backgroundColor: "primary.main",
                            color: "primary.contrastText",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: 4,
                        }}
                    >
                        <Typography variant="h4" gutterBottom>Bienvenue</Typography>
                        <Typography variant="body1" textAlign="center">
                            Plateforme Achat des forfaits
                        </Typography>
                    </Box>

                    {/* Right Side */}
                    <Box
                        sx={{
                            flex: 1,
                            backgroundColor: "background.paper",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            padding: 4,
                        }}
                    >
                        {showOtpVerification ? (
                        
                            <Box>
                                {otpError && (
                                    <Typography color="error" sx={{ mb: 2 }}>
                                        {otpError}
                                    </Typography>
                                )}
                                <Typography sx={{ textAlign: "center", mb: 2 }}>
                                    {otpMessage || "Veuillez saisir le code à 6 chiffres affiché sur votre application mobile."}
                                </Typography>
                                <TextField
                                    fullWidth
                                    label="Code OTP"
                                    value={codeOTP || ""}
                                    onChange={(e) => setCodeOTP(e.target.value)}
                                    inputProps={{ maxLength: 6 }}
                                    sx={{ mb: 2 }}
                                />
                                <Typography
                                    onClick={handleMailClick}
                                    sx={{
                                        color: "primary.main",
                                        cursor: "pointer",
                                        fontSize: "14px",
                                        textDecoration: "underline",
                                        mb: 2,
                                        textAlign: "center"
                                    }}
                                >
                                    Envoyer le code par mail
                                </Typography>
                                <Button
                                    fullWidth
                                    onClick={() => dispatch(loginAction({
                                        ...formValuesRef.current,
                                        otp: codeOTP
                                    }))}
                                    sx={{
                                        backgroundColor: "primary.main",
                                        color: "primary.contrastText",
                                        borderRadius: "25px",
                                        padding: "10px",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        "&:hover": { backgroundColor: "primary.dark" },
                                    }}
                                >
                                    Valider
                                </Button>
                            </Box>
                        ) : (
                            
                            <Formik
                                initialValues={loginInitialValues}
                                validationSchema={loginValidationSchema}
                                onSubmit={submitHandler}
                                innerRef={formRef}
                            >
                                {({ submitForm, values }) => {
                                    formValuesRef.current = values;
                                    return (
                                        <PuiFormikForm>
                                            <PuiGrid container spacing={2}>
                                                <PuiGrid item xs={12}>
                                                    <PuiTextField
                                                        label="Nom d'utilisateur"
                                                        name={loginFormNames.LOGIN_USERNAME_FORM_NAME}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <Person style={{ color: theme.palette.secondary.main, fontSize: "24px" }} />
                                                                </InputAdornment>
                                                            ),
                                                            style: {
                                                                borderRadius: "30px",
                                                                backgroundColor: alpha(theme.palette.secondary.main, 0.08),
                                                                padding: "12px",
                                                            },
                                                        }}
                                                    />
                                                </PuiGrid>
                                                <PuiGrid item xs={12}>
                                                    <PuiTextField
                                                        label="Mot de passe"
                                                        type={showPassword ? "text" : loginFormNames.LOGIN_SECRET_INPUT_TYPE}
                                                        name={loginFormNames.LOGIN_SECRET_FORM_NAME}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <Lock style={{ color: theme.palette.secondary.main, fontSize: "24px" }} />
                                                                </InputAdornment>
                                                            ),
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton onClick={handleClickShowPassword} edge="end">
                                                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                            style: {
                                                                borderRadius: "30px",
                                                                backgroundColor: alpha(theme.palette.secondary.main, 0.08),
                                                                padding: "12px",
                                                            },
                                                        }}
                                                    />
                                                </PuiGrid>
                                                <PuiGrid item xs={12}>
                                                    <Button
                                                        onClick={submitForm}
                                                        fullWidth
                                                        sx={{
                                                            backgroundColor: "primary.main",
                                                            color: "primary.contrastText",
                                                            borderRadius: "25px",
                                                            padding: "10px",
                                                            fontSize: "16px",
                                                            fontWeight: "600",
                                                            "&:hover": {
                                                                backgroundColor: "primary.dark",
                                                                boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.3)",
                                                            },
                                                        }}
                                                    >
                                                        Se connecter
                                                    </Button>
                                                </PuiGrid>
                                            </PuiGrid>
                                        </PuiFormikForm>
                                    );
                                }}
                            </Formik>
                        )}
                    </Box>
                </Paper>
            </Box>

            
            <MFAPopup
                open={showMfaPopup}
                onClose={() => setShowMfaPopup(false)}
                qrCodeBase64={qrCodeUrl}
                secretCode={secret}
                codeOTP={codeOTP}
                setCodeOTP={setCodeOTP}
                handleRegisterClick={handleRegisterClick}
                mfaErrorMessage={mfaErrorMessage}
            />
        </>
    );
};

export default LoginPage;